// extracted by mini-css-extract-plugin
export default {"container":"EmptyResult_container__113T6"};